import httpClientService from '@/services/httpClientService';

export default {
	getAllUsers: () => httpClientService.Get('/ConfigUserModule/api/User'),
	getByUserId: (id) =>
		httpClientService.Get('/ConfigUserModule/api/User/' + id),
	insertUser: (param) =>
		httpClientService.Post('/ConfigUserModule/api/User', param),
	updateUser: (param) =>
		httpClientService.Put(`/ConfigUserModule/api/User/${param.Id}`, param),
	deleteUser: (id) =>
		httpClientService.Delete('/ConfigUserModule/api/User/' + id),
};
